import {
	Button,
	ButtonSize,
	ColourStateOutline,
	ContentBlock,
	FlexGap,
	FlexJustify,
	Padding,
	Tooltip,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';
import { faRuler } from '@fortawesome/pro-solid-svg-icons/faRuler';
import { faTruckFast } from '@fortawesome/pro-solid-svg-icons/faTruckFast';
import { useNavigate } from 'react-router';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemDimensionsMeta() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	if (mailItemData?.itemSize?.width === null) {
		return null;
	}

	return (
		<ContentBlock
			title={t('mailItem.labels.dimensions')}
			content={`${mailItemData?.itemSize?.width} ${mailItemData?.itemSize?.height !== null ? `x ${mailItemData?.itemSize?.height}` : ''}  ${mailItemData?.itemSize?.depth !== null ? `x ${mailItemData?.itemSize?.depth}` : ''} CM`}
			iconContent={{ icon: faRuler, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
			addon={
				mailItemData?.mailLocationId !== 7 && mailItemData?.itemSize?.weight !== null ? (
					<Tooltip content={t('mailItem.actions.shipping')}>
						<Button
							title={t('mailItem.actions.shipping')}
							onClick={() =>
								navigate(
									`/shipping-calculator/${mailItemData?.itemSize?.weight}/${mailItemData?.itemSize?.width}/${mailItemData?.itemSize?.height}/${mailItemData?.itemSize?.depth}`,
								)
							}
							icon={faTruckFast}
							iconOnly
							size={ButtonSize.Small}
							colour={ColourStateOutline.Secondary}
						/>
					</Tooltip>
				) : undefined
			}
		/>
	);
}

export { MailItemDimensionsMeta };
